import { TXTCLI_Required } from '../translations';
import type { Error } from '../types';

export const required =
  (message: Error['message'] | null = TXTCLI_Required) =>
  (value: string) => ({
    valid: !!value,
    message: message !== null ? message : undefined
  });
